//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@/assets/css/animate.min.css';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import '@/main.scss';

import { createApp } from 'vue/dist/vue.esm-bundler';
import store from '@/store';
import App from '@/App.vue';
import router from '@/router';
import axios, { AxiosInstance } from 'axios';
import VueAxios from 'vue-axios';
import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import { FontAwesomeIcon } from '@/assets/plugins/font-awesome';
import Toaster from '@meforma/vue-toaster';
import { vfmPlugin } from 'vue-final-modal';
import VueSweetalert2 from 'vue-sweetalert2';
import VueTippy from 'vue-tippy';
import app_mixin from '@/mixin';
import lib from '@/lib';

const app = createApp(App);
const metaManager = createMetaManager();

window['appInstance'] = null;
window['appComponent'] = null;
window['storeInstance'] = null;

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$store = store;
//app.config.productionTip = false;
//app.config.debug = true;
//app.config.devtools = true;
app.use(router);
app.use(store);
app.use(VueAxios, axios);
app.use(store.state.app.i18n);
app.use(metaManager);
app.use(Toaster);
app.use(vfmPlugin);
app.use(VueSweetalert2);
app.use(VueTippy, {
	directive: 'tippy', // => v-tippy
	component: 'tippy', // => <tippy/>
	componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
	defaultProps: {
		placement: 'auto-end',
		allowHTML: true,
		theme: 'light',
		maxWidth: 400,
		arrow: true,
		delay: [200, 0],
		duration: 0,
		//appendTo: 'parent',
    },
	content: (reference) => reference.getAttribute('title') || reference.getAttribute('content'),
});
app.component('font-awesome-icon', FontAwesomeIcon);
lib.addMixin(app_mixin);
app.mount('#app');

window['lib'] = lib;
window['axios'] = axios;

window['appInstance'] = app;
window['storeInstance'] = store;

// Автопродление токена в случае необходимости
axios.interceptors.response.use(
	response => response,
	async error => {
		const originalRequest = error.config;
		
		// Проверка отсутствия токена, чтобы исключить повторную попытку
		if (!originalRequest.headers['Authorization'] || originalRequest._retry) {
			return Promise.reject(error);
		}
		
		if (error.response.status === 401) {
			originalRequest._retry = true; // Установка флага для предотвращения повторных попыток
			
			try {
				// Проверка черного списка токенов перед обновлением
				const token = originalRequest.headers['Authorization'].split(' ')[1];
				const isBlacklisted = await store.state.app.auth.doCheckTokenBlacklist(token);
				if (isBlacklisted) {
					store.state.app.auth.doLogout();
					return Promise.reject(error);
				}
				
				// Проверка наличия сессии
				const isSessionValid = await store.state.app.auth.doCheckSession();
				if (!isSessionValid) {
					store.state.app.auth.doLogout();
					return Promise.reject(error);
				}
				
				const newToken = await store.state.app.auth.doRefreshToken();
				axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
				originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
				if (newToken) {
					axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
					originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
					
					// ПОВТОРНО выполняем запрос с новым токеном
					return axios(originalRequest);
				} else {
					throw new Error('Failed to refresh token');
				}
			} catch (refreshError) {
				// Обработка ошибки обновления токена
				console.error('Ошибка обновления токена', refreshError);
				
				if (refreshError.response && refreshError.response.status === 401) {
					store.state.app.auth.doLogout();
				}
				
				return Promise.reject(refreshError);
			}
		}
		return Promise.reject(error);
	}
);
